module.exports = __webpack_public_path__ + "static/media/padlock.6d1ca21d.svg";